import type { WebWidgetModel, WidgetMetaData } from '@web/types';
import type { ImageEntity } from '@sites/entity-core';

import { Widgets } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';
import { createImage, createImageStylesLegacy } from '@sites/entity-core';

import { ImageViewComponent } from '../components/image-view/image-view.component';
import { ImageControlComponent } from '../components/image-control/image-control.component';

// DEFAULT COMPONENT SETTINGS — sourced from the canonical entity factory in
// @sites/entity-core. Image registers `params.type: ['default', 'specific', 'zero']`;
// the `'specific'` placement shares the default shape, so only the zero tag
// (`meta.type`) selects the extended-position + imagePosition variant. The
// envelope's structured `styles` group is seeded alongside `data` (the factory
// copies `widget.styles` onto the new entity).
const imageData = (_translate: unknown, meta?: WidgetMetaData): ImageEntity['data'] =>
    (meta?.type === 'zero' ? createImage('zero') : createImage('default')).data;
// END DEFAULT SETTINGS

export const imageWidgetModel: WebWidgetModel = {
    componentView: ImageViewComponent,
    componentControl: ImageControlComponent,
    name: Widgets.IMAGE,
    label: 'widget_image_label',
    data: imageData,
    styles: createImageStylesLegacy(),
    permission: defaultWidgetPermission,
    params: { ...defaultWidgetParams, type: ['default', 'specific', 'zero'] },
    // Control + view components own the form via `WebLegacyWidgetSignalFormService`.
    signalForm: true,
};
